import { createContext , useContext} from "react";

const DilContext= createContext()

export {
    DilContext,useContext 
}